import React, { useState, useEffect, useReducer } from "react";
import { useTranslation } from "react-i18next";
import TicketForm from "./TicketForm";

const TicketsForms = (props) => {
  const [t] = useTranslation("global");

  // 1️⃣ Single source of truth: ticket data
  const [tickets, setTickets] = useState([
    { id: 0, nameOk: false, emailOk: false, discountOk: false },
  ]);

  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);

  // 2️⃣ Derived count (automatically from tickets.length)
  const numberTickets = tickets.length;

  // 3️⃣ Update ticket count by user input
  const numberHandler = (value) => {
    const sanitized = Math.max(1, Number(value) || 1);

    setTickets((prev) => {
      const diff = sanitized - prev.length;

      if (diff > 0) {
        // Add new empty tickets
        const newOnes = Array.from({ length: diff }, (_, i) => ({
          id: prev.length + i,
          nameOk: false,
          emailOk: false,
          discountOk: false,
        }));
        return [...prev, ...newOnes];
      } else if (diff < 0) {
        // Remove from the end
        return prev.slice(0, sanitized);
      }
      return prev;
    });

    forceUpdate();
  };

  // 4️⃣ Handle deletion of one ticket
  const handleDeleteTicket = (index) => {
    setTickets((prev) =>
      prev
        .filter((_, i) => i !== index)
        .map((t, i) => ({ ...t, id: i })) // reindex cleanly
    );
  };

  // 5️⃣ Update validation state from child
  const updateTicketValidation = (newObjShowOk) => {
    setTickets((prev) =>
      prev.map((t, i) => ({
        ...t,
        ...(newObjShowOk[i] || {}),
      }))
    );
  };

  return (
    <div className="grid grid-cols-1 xl:pr-20 xl:px-20 bg-white text-3xl xl:-mt-2 -mt-8 xl:py-10 md:py-10 sm:py-10">
      <div className="w-full">
        <div
          style={{ fontFamily: "sf-pro-regular" }}
          className="text-gray-tikets xl:pl-6 xl:pr-20 pl-6 pr-6 text-base sm:text-sm md:text-md xl:text-xl"
        ></div>

        <div className="grid grid-cols-10 py-10 xl:pl-0 pl-6">
          <div className="w-2 flex items-center">{t("tickets.amount")}</div>
          <input
            autoComplete="off"
            type="number"
            name="number"
            id="number"
            className="block border-2 xl:ml-12 ml-24 text-center xl:w-full w-28 h-14 text-3xl text-blue-tikets bg-transparent dark:text-blue-tikets dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer text-4xl"
            placeholder=" "
            min="1"
            value={numberTickets}
            required
            onInput={(e) => numberHandler(e.target.value)}
            onWheel={(e) => e.target.blur()}
          />
        </div>

        {/* 6️⃣ Pass clean props down */}
        <TicketForm
          tickets={tickets}
          numberTickets={numberTickets}
          ticketId={props.id}
          price={Number(props.price)}
          item={props.item}
          onDeleteTicket={handleDeleteTicket}
          onUpdateValidation={updateTicketValidation}
        />
      </div>
    </div>
  );
};

export default TicketsForms;
